import { FC, useState } from "react";
import { useBetween } from "use-between";
import { Button } from "../../../utils/Button";
import { propsInterfaceFormGroupInput } from "../../../utils/form/FormGroupInput";
import { BTCreateContract6 } from "../BTContract/BTCreateContract6";
import { ModalForm } from "../../../utils/modal/ModalForm";
import { AlertModal } from "../../../utils/modal/AlertModal";

const ActionDataGrid6: FC<actionDataGridProps> = (props) => {
    const [showModalMenu3, setShowModalMenu3] = useState(false);
    const [showConfirm3, setShowConfirm3] = useState(false);
    const { deleteRow6, dataModelo6, setDataModelo6, addRowStructure3,updateRow6 } = useBetween(BTCreateContract6);
    const columInput=3;
    const [arrayInput3] = useState<propsInterfaceFormGroupInput[]>([
        {
            columInput: columInput,
            campo: "fatherStructure2",
            label: "Estructura Padre",
            type: "autocomplete",
            advanceOptions: {
                id: "fatherStructure2",
                multiple: false,
                placeholder: "Ingrese Estructura",
                options: [
                    { text: "Plato de fondo", value: "1" },
                    { text: "Entrada", value: "2" },
                    { text: "Postre", value: "3" },
                    { text: "Acompañamiento", value: "4" }
                ]
            },
            onChange: (item: any) => {
            },
            className: "form-control form-control-lg step-2  input-contract"
        },
        {
            columInput: columInput,
            campo: "mainIngredients",
            label: "Ingredientes Principales",
            type: "autocomplete",
            advanceOptions: {
                id: "mainIngredients",
                placeholder: "Ingrese Ingredientes",
                multiple: false,
                options: [
                    { text: "Pollo Entero", value: "1" },
                    { text: "Vacuno Entero", value: "2" },
                    { text: "Papas", value: "3" },
                    { text: "Arroz", value: "4" }
                ]
            },
            className: "form-control form-control-lg input-contract"
        },
        {
            columInput: columInput,
            campo: "recipe",
            label: "Receta",
            type: "autocomplete",
            advanceOptions: {
                id: "recipe",
                placeholder: "Ingrese Receta",
                multiple: false,
                options: [
                    { text: "Pollo Asado", value: "1" },
                    { text: "Pollo al Jugo", value: "2" },
                    { text: "Pollo al Coñac", value: "3" }
                ]
            },
            className: "form-control form-control-lg input-contract"
        },
        {
            columInput: columInput,
            campo: "cycleWeek",
            placeholder: "Día Ciclo",
            label: "Día Cilco",
            type: "text",
            className: "form-control form-control-lg mt-2 input-contract"
        }
    ])
    return (
        <>
            {/* <Button
                className="btn-table"
                type="button"
                onClick={() => {
                    addRowStructure3(props)
                    setShowModalMenu3(true)
                }}
            ><i className="bi bi-pencil-square icon-action"></i>
            </Button> */}
            <Button
                className="btn-table"
                onClick={() => {
                    setShowConfirm3(true);
                }}
                type="button"
            ><i className="bi bi-trash3-fill icon-action"></i>
            </Button>
            {
                showConfirm3
                &&
                <AlertModal
                    title={"Alerta"}
                    message={"¿Esta seguro de eliminar?"}
                    save={() => {
                        deleteRow6(props)
                        setShowConfirm3(false)
                    }}
                    saveName="Eliminar"
                    show={showConfirm3}
                    close={()=>{
                        setShowConfirm3(false)
                    }}
                />
            }
        </>
    )
}
interface actionDataGridProps {
    edit?(): void,
    delete?(): void,
    dataRow?: any
}
export { ActionDataGrid6 }